import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unitySemanticDarkColorTokens, unitySemanticLightColorTokens } from '../unityTokens';
import { green, white } from './colors';
import { border } from './border';

export const input = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['input'] => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          // our input states are deviating from Unity's because our hierarchy is slightly different.
          // we put inputs directly on top of the page background color, whereas Unity always puts
          // them on top of a container. In dark mode their colors are fine, in light mode they're
          // too low contrast
          backgroundColor: unitySemanticLightColorTokens['--semantic-bg-input-hover'],
          hoverBackgroundColor: unitySemanticLightColorTokens['--semantic-bg-input-active'],
          disabledBackgroundColor: unitySemanticLightColorTokens['--semantic-bg-input-hover'],
          borderColor: 'transparent',
          focusBorderColor: 'transparent',
          hoverBorderColor: 'transparent',
          placeholderColor: unitySemanticLightColorTokens['--semantic-text-placeholder'],
          labelColor: unitySemanticLightColorTokens['--semantic-text-placeholder'],
          errorColor: unitySemanticLightColorTokens['--semantic-text-destructive'],
          selected: unitySemanticLightColorTokens['--semantic-bg-interactive-neutral-active'],
        }
      : {
          backgroundColor: unitySemanticDarkColorTokens['--semantic-bg-input-default'],
          hoverBackgroundColor: unitySemanticDarkColorTokens['--semantic-bg-input-hover'],
          disabledBackgroundColor: unitySemanticDarkColorTokens['--semantic-bg-input-disabled'],
          borderColor: 'transparent',
          focusBorderColor: 'transparent',
          hoverBorderColor: 'transparent',
          placeholderColor: unitySemanticDarkColorTokens['--semantic-text-placeholder'],
          labelColor: unitySemanticDarkColorTokens['--semantic-text-placeholder'],
          errorColor: unitySemanticDarkColorTokens['--semantic-text-destructive'],
          selected: unitySemanticDarkColorTokens['--semantic-bg-interactive-neutral-active'],
        };
  }

  const borderPalette = border(mode, opts)!;
  return mode === 'light'
    ? {
        backgroundColor: white,
        borderColor: borderPalette.prominent,
        selected: green[50],
      }
    : {
        backgroundColor: 'inherit',
        borderColor: borderPalette.prominent,
        selected: green[800],
      };
};
